<div class="wrap" [ngClass]="{ open: showMenu }">
  <span class="close btn" (click)="hideMenu()">
    <span class="icon-status-cross"></span>
  </span>

  <div class="items">
    <h2>Allergies</h2>

    <div>
      <button class="btn clear" (click)="clearAllergies()">
        <span class="icon-status-cross"></span>
        <span>Clear all</span>
      </button>
    </div>

    <div class="allergies-list" [class.any-selected]="anySelected()">
      @for (allergy of allAllergens; track allergy) {
        <span class="allergy" [class.selected]="allergySelected(allergy.name)" (click)="toggleAllergy(allergy.name)">
          <img class="icon" [src]="'assets/allergens/allergen-' + allergy.name + '.svg'" />
          <span class="label">{{ allergy.displayName }}</span>
        </span>
      }
    </div>
  </div>
</div>
